(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7696],{

/***/ 97696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "metadata": function() { return /* binding */ metadata; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _context_store_useBrandConfigStore_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78525);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var metadata = {
  title: 'Home',
  openGraph: {
    title: 'Home'
  }
};

function HeadLayout() {
  var _brandConfig$themeCon, _brandConfig$themeCon2;

  var _useBrandConfigStore = (0,_context_store_useBrandConfigStore_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (state) {
    return {
      brandConfig: state.config
    };
  }),
      brandConfig = _useBrandConfigStore.brandConfig;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
        rel: "shortcut icon",
        href: "/favicon.ico",
        type: "image/x-icon"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        httpEquiv: "cache-control",
        content: "max-age=172800"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title", {
        children: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.websiteTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "robots",
        content: "/sitemap.xml"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.websiteDescription,
        name: "description"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
        rel: "canonical",
        href: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.canonicalUrl
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:site_name",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.brandName
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:description",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.websiteDescription
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:title",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.websiteTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:url",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.websiteUrl
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image",
        name: "image",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.brandLogo
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:card",
        content: "summary_large_image"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:title",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.websiteTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:description",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.websiteDescription
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:image",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : brandConfig.brandLogo
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "msapplication-TileColor",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : (_brandConfig$themeCon = brandConfig.themeConfig) === null || _brandConfig$themeCon === void 0 ? void 0 : _brandConfig$themeCon.container.backgroundColor.primary
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "theme-color",
        content: brandConfig === null || brandConfig === void 0 ? void 0 : (_brandConfig$themeCon2 = brandConfig.themeConfig) === null || _brandConfig$themeCon2 === void 0 ? void 0 : _brandConfig$themeCon2.container.backgroundColor.primary
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
        dangerouslySetInnerHTML: {
          __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${"GTM-KJVQHDH3"}');`
        }
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (HeadLayout);

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ })

}]);